import api from "../config/api"

export const getStockMaster = async () => {
    return await api().get('/stockMaster/')
}

export const getStockMasterById = async (id: number) => {
    return await api().get(`/stockMaster/?id=${id}`)
}

export const updateStockMaster = async (data: any, id: number | undefined) => {
    return await api().put(`/stockMaster/?id=${id}`, data)
}

